/**
 * ks-workflow – Arbeitsweise
 *
 * Jede Karte lässt sich unabhängig auf- und zuklappen. Ein Klick öffnet die
 * Karte (zeigt ihren Text), ein erneuter Klick auf dieselbe Karte schließt
 * sie wieder. Andere geöffnete Karten bleiben dabei offen.
 */
export default function initWorkflow(selector = '[data-ks-workflow]') {
  const groups = document.querySelectorAll(selector);

  groups.forEach((group) => {
    const cards = Array.from(group.querySelectorAll('.ks-workflow__card'));
    if (!cards.length) return;

    cards.forEach((card) => {
      const toggle = card.querySelector('.ks-workflow__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const isOpen = card.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  });
}
